/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { EventBusModule } from "@vlinder-web/event-bus-module-react";
import { FSMFactoryModule } from "@vlinder-web/state-machine-factory-module-react";
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import { BaseApplication } from "./base/baseApplication";
import { UnitTest } from "./unit.test";
import {
    TrafficLightService,
    DeviceInfoService,
    DummyRestService,
    DummyGraphQLService,
    NetworkOperatorService,
    AnalyticsService,
    ProductsService,
    TransactionService,
    CampaignService,
    FeedbackService,
    PersonaService,
    QRService,
    AssetsService,
    ProvenanceService,
    RolesService,
    DashboardService,
    CollectionService,
    BatchLevelQRService,
    AdminBatchLevelQRService,
    UsersService,
    SapService,
    LoginTOSService,
    ReportService,
    AddNewCollectionService,
    ClubRegistrationService,
    CreateQRCodesService,
} from "../services";

// import { DEFAULT_APP_CONFIG } from "../config/default.config";
import { useAuth } from "../services/auth-service/auth.provider";
import { StorageModule } from "@vlinder-web/storage-module-react";

const { getToken, getOrganizationId } = useAuth();
export class VApplication extends BaseApplication {
    private static instance: VApplication;

    private constructor(options: any = {}) {
        super(options);

        this.setupBindings();

        //Modules
        this.initModules();

        //Services
        this.initServices();
    }

    static getInstance(options: any = {}) {
        if (!this.instance) {
            this.instance = new VApplication(options);
        }
        return this.instance;
    }

    // @ts-ignore
    async start() {
        await this.initRunLevel();
        await this.unitTest();
    }

    setupBindings() {
        //------------->>>>>--------------//
        // this.configure("services.DummyRestService", {
        //     baseURL: DEFAULT_APP_CONFIG?.servers.rest.dummyRestServer.baseURL,
        // });
        //------------->>>>>--------------//
    }

    async initRunLevel() {
        //------------->>>>>--------------//
        const storageSrv = StorageModule.getInstance();
        const DEFAULT_APP_CONFIG = storageSrv.get("appConfig", "session");
        console.log(`env data:`, DEFAULT_APP_CONFIG);
        const graphqlModule = this.getSync(
            "services.GraphqlServerModule"
        ) as GraphqlServerModule;
        if (graphqlModule) {
            type TClient = typeof DEFAULT_APP_CONFIG.servers.graphql[0];
            DEFAULT_APP_CONFIG.servers.graphql.forEach(
                async (client: TClient) => {
                    await graphqlModule
                        .createClient(client.name, {
                            url: client.url,
                            //url: "https://3d93-103-143-6-34.ngrok-free.app/",
                            getContext: this.getGraphQLContext.bind(this),
                        })
                        .then((res) => {
                            console.log(`initRunLevel check`, res);
                        })
                        .catch((err) => {
                            console.warn(
                                `error in initRunLevel  ${err.message}`
                            );
                        });
                }
            );
        }
        //------------->>>>>--------------//

        const storageService = this.getSync(
            "services.StorageModule"
        ) as StorageModule;
        await storageService.init();
    }

    async unitTest() {
        const ut = new UnitTest(VApplication);
        ut.run();
    }

    initModules() {
        this.service("services.FSMFactoryModule", FSMFactoryModule);
        this.service("services.EventBusModule", EventBusModule);
        this.service("services.GraphqlServerModule", GraphqlServerModule);
        this.service("services.StorageModule", StorageModule);
    }

    initServices() {
        this.service("services.TrafficLightService", TrafficLightService);
        this.service("services.DummyRestService", DummyRestService);
        this.service("services.DeviceInfoService", DeviceInfoService);
        this.service("services.DummyGraphQLService", DummyGraphQLService);
        this.service("services.NetworkOperatorService", NetworkOperatorService);
        this.service("services.AnalyticsService", AnalyticsService);
        this.service("services.ProductsService", ProductsService);
        this.service("services.TransactionService", TransactionService);
        this.service("services.CampaignService", CampaignService);
        this.service("services.FeedbackService", FeedbackService);
        this.service("services.PersonaService", PersonaService);
        this.service("services.QRService", QRService);
        this.service("services.AssetsService", AssetsService);
        this.service("services.ProvenanceService", ProvenanceService);
        this.service("services.RolesService", RolesService);
        this.service("services.DashboardService", DashboardService);
        this.service("services.CollectionService", CollectionService);
        this.service("services.BatchLevelQRService", BatchLevelQRService);
        this.service(
            "services.AdminBatchLevelQRService",
            AdminBatchLevelQRService
        );
        this.service("services.UsersService", UsersService);
        this.service("services.SapService", SapService);
        this.service("services.LoginTOSService", LoginTOSService);
        this.service("services.ReportService", ReportService);
        this.service("services.addNewCollection", AddNewCollectionService);
        this.service(
            "services.ClubRegistrationService",
            ClubRegistrationService
        );
        this.service("services.CreateQRCodesService", CreateQRCodesService);
    }

    private getGraphQLContext() {
        const deviceInfoService = this.getSync(
            "services.DeviceInfoService"
        ) as DeviceInfoService;
        console.log("graphqlContext call", getToken());
        //FIXME:
        return {
            headers: {
                authentication: getToken(),
                "org-id": getOrganizationId(),
                headers: {
                    ...{ ...deviceInfoService?.getDeviceInfo() },
                    ...{ ...deviceInfoService?.getAppInfo() },
                },
            },
        };
    }
}
